import { atom, PrimitiveAtom } from 'jotai'

export const userIdAtom = atom<string | null>(null) as PrimitiveAtom<string | null>
